import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/adquisiciones/dashboard', documento: 'adquisiciones', acceso: 'sesion', filas: ['091'],
  cita: 'Areas/Adquisiciones/Controllers/DevolucionesController.cs',
  alias: ['/sistema/adquisiciones'],
} satisfies RutaProd;
